import { MenuItem, TextField } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useBoundValue } from "lib/@components/binding/use-bound-value"
import { getDefaultRequestedFieldType, getRequestedFieldTypes } from "./requested-field-types"

/**
 * Selector over the supported requested-field types, bound to `field` (default "type")
 * on the surrounding `Bound` target. Changing the type triggers the bound onChange so the
 * parent editor re-renders (revealing/hiding the choice options editor) and the share dialog
 * persists through its normal save chain.
 */
export function RequestedFieldTypeSelect({ field = "type", ...props }) {
    const { onChange } = useBoundContext()
    const defaultType = getDefaultRequestedFieldType()
    const [value, setValue] = useBoundValue(field, defaultType)
    const types = getRequestedFieldTypes()

    return (
        <TextField
            select
            size="small"
            label="Type"
            sx={{ minWidth: 140, ...props.sx }}
            data-cy="requested-field-type"
            value={value ?? defaultType}
            onChange={handleChange}
            {...props}
        >
            {createTypeOptions()}
        </TextField>
    )

    function handleChange(event) {
        setValue(event.target.value)
        onChange?.()
    }

    function createTypeOptions() {
        // MUI Select inspects immediate children, so these must be direct MenuItem elements.
        const options = []
        for (const option of types) {
            options.push(createTypeOption(option))
        }
        return options
    }

    function createTypeOption(option) {
        return (
            <MenuItem key={option.value} value={option.value}>
                {option.label}
            </MenuItem>
        )
    }
}
